var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6613_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.904515 8.99889C0.405223 8.99889 0 8.59084 0 8.08807V0.910819C0 0.408047 0.405223 0 0.904515 0H8.34686C8.84615 0 9.25138 0.408047 9.25138 0.910819C9.25138 1.41359 8.84615 1.82164 8.34686 1.82164H1.80903V8.08807C1.80903 8.59084 1.40381 8.99889 0.904515 8.99889Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18863 23.0004H1.06467C0.565379 23.0004 0.160156 22.5924 0.160156 22.0896V14.5954C0.160156 14.0926 0.565379 13.6846 1.06467 13.6846C1.56396 13.6846 1.96919 14.0926 1.96919 14.5954V21.1788H8.19225C8.69154 21.1788 9.09676 21.5868 9.09676 22.0896C9.09676 22.5924 8.69154 23.0004 8.19225 23.0004H8.18863Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.081 22.9999H14.5117C14.0039 22.9999 13.5918 22.5733 13.5918 22.0476C13.5918 21.5219 14.0039 21.0952 14.5117 21.0952H21.161V14.5432C21.161 14.0175 21.5731 13.5908 22.081 13.5908C22.5888 13.5908 23.0009 14.0175 23.0009 14.5432V22.0476C23.0009 22.5733 22.5888 22.9999 22.081 22.9999Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0949 8.99889C21.5956 8.99889 21.1904 8.59084 21.1904 8.08807V1.82164H14.6526C14.1533 1.82164 13.748 1.41359 13.748 0.910819C13.748 0.408047 14.1533 0 14.6526 0H22.0949C22.5942 0 22.9994 0.408047 22.9994 0.910819V8.08807C22.9994 8.59084 22.5942 8.99889 22.0949 8.99889Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8487 11.1009H4.78342C4.28413 11.1009 3.87891 10.6929 3.87891 10.1901V5.08953C3.87891 4.58676 4.28413 4.17871 4.78342 4.17871H9.8487C10.348 4.17871 10.7532 4.58676 10.7532 5.08953V10.1901C10.7532 10.6929 10.348 11.1009 9.8487 11.1009ZM5.68794 9.2793H8.94419V6.00035H5.68794V9.2793Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8487 19.4808H4.78342C4.28413 19.4808 3.87891 19.0728 3.87891 18.57V13.4694C3.87891 12.9666 4.28413 12.5586 4.78342 12.5586H9.8487C10.348 12.5586 10.7532 12.9666 10.7532 13.4694V18.57C10.7532 19.0728 10.348 19.4808 9.8487 19.4808ZM5.68794 17.6592H8.94419V14.3802H5.68794V17.6592Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5323 11.1009H13.467C12.9677 11.1009 12.5625 10.6929 12.5625 10.1901V5.08953C12.5625 4.58676 12.9677 4.17871 13.467 4.17871H18.5323C19.0316 4.17871 19.4368 4.58676 19.4368 5.08953V10.1901C19.4368 10.6929 19.0316 11.1009 18.5323 11.1009ZM14.3715 9.2793H17.6278V6.00035H14.3715V9.2793Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8283 18.3271C13.3291 18.3271 12.9238 17.8862 12.9238 17.3397V14.5781C12.9238 14.0317 13.3291 13.5908 13.8283 13.5908C14.3276 13.5908 14.7329 14.0317 14.7329 14.5781V17.3397C14.7329 17.8862 14.3276 18.3271 13.8283 18.3271Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6084 15.4125H16.2856C15.8261 15.4125 15.457 15.0044 15.457 14.5016C15.457 13.9989 15.8297 13.5908 16.2856 13.5908H18.6084C19.0679 13.5908 19.4369 13.9989 19.4369 14.5016C19.4369 15.0044 19.0642 15.4125 18.6084 15.4125Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6084 18.3265H16.2856C15.8261 18.3265 15.457 17.9185 15.457 17.4157C15.457 16.9129 15.8297 16.5049 16.2856 16.5049H18.6084C19.0679 16.5049 19.4369 16.9129 19.4369 17.4157C19.4369 17.9185 19.0642 18.3265 18.6084 18.3265Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6613_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.f88001a5d2d3a86558e808c7fc8282d1.svg";
export { ForwardRef as ReactComponent };